import { useState } from 'react';
import { useSelector } from 'react-redux';

/**
 * Custom hook to manage selected attachment state.
 * @returns {[any, Function]} selectedAttachment, setSelectedAttachment
 */
export default function useSelectedAttachmentHook(props) {
    const [selected_attachments, setSelectedAttachments] = useState([]);
    const { can_access_content_destroy, can_access_content_update, can_access_content_download } = useSelector(state => state.content);

    const toggleSelectedAttachment = (e, attachment) => {
        e.stopPropagation();
        e.preventDefault();

        if (!can_access_content_destroy && !can_access_content_update && !can_access_content_download) {
            return;
        }

        if (selected_attachments.some(item => item.id === attachment.id)) {
            setSelectedAttachments(prevAttachments => prevAttachments.filter(item => item.id !== attachment.id));
        } else {
            setSelectedAttachments(prevAttachments => [...prevAttachments, attachment]);
        }
    }

    return {selected_attachments, setSelectedAttachments, toggleSelectedAttachment};
}